import $i18n from '@/i18n';

export const UrlEnum = {
  recover: '/rest/intercnn/app/publish/unblock',
  forbidden: '/rest/intercnn/app/publish/block',
};

export const filterKeys = [
  {
    key: 'appName',
    label: $i18n.get({
      id: 'aopf.pages.miniapp.drawer.form.Miniapp.Name',
      dm: 'Miniapp Name',
    }),
  },
  {
    key: 'appId',
    label: $i18n.get({
      id: 'aopf.pages.miniapp.version.info.title.Miniapp.ID',
      dm: 'Miniapp ID',
    }),
  },
];

export const status = 'ONLINE,OFFLINE,BLOCKED';

export const Category = [
  {
    key: 'systematicCategory',
    label: $i18n.get({
      id: 'aopf.pages.miniAppStore.select.systematicCategory',
      dm: '系统类目',
    }),
  },
  {
    key: 'operationCategory',
    label: $i18n.get({
      id: 'aopf.pages.miniAppStore.select.operationCategory',
      dm: '运营类目',
    }),
  },
]
